import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NoChapContent from './NoChapContent';

const AddChapterModal = ({
    availableChapterLanguages,
    setAvailableChapterLanguages,
    setCurrentSelectedLanguage,
    isAddModalOpen,
    setIsAddModalOpen,
    setShowNoChap
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            open={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
            disablePortal
        >
            <Box className="modal-content-box">
                <NoChapContent
                    availableChapterLanguages={availableChapterLanguages}
                    setAvailableChapterLanguages={setAvailableChapterLanguages}
                    setCurrentSelectedLanguage={setCurrentSelectedLanguage}
                    setIsAddModalOpen={setIsAddModalOpen}
                    setShowNoChap={setShowNoChap}
                />
                <Box className="modal-footer-box">
                    <Button onClick={() => setIsAddModalOpen(false)} className="modal-cancel-button">
                        {t('buttons.cancel')}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default AddChapterModal;
